var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZendesk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 61,
    viewBox: "0 0 84 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2182 9.37012V35.4732H18.5952L40.2182 9.37012Z",
    fill: "#16140C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2182 0C40.2182 5.97132 35.378 10.8115 29.4067 10.8115C23.4354 10.8115 18.5952 5.97132 18.5952 0H40.2182Z",
    fill: "#16140C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7812 35.4716C43.7812 29.5003 48.6214 24.6602 54.5927 24.6602C60.564 24.6602 65.402 29.5003 65.402 35.4716H43.7812Z",
    fill: "#16140C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7817 26.1053V0H65.4025L43.7817 26.1053Z",
    fill: "#16140C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4516 53.4126C58.2227 51.9393 57.3427 50.8548 55.5826 50.8548C53.947 50.8548 52.8136 51.7837 52.5114 53.4126H58.4516ZM55.8582 57.8061C57.2427 57.8061 58.2494 57.2372 58.8538 56.6416L60.3406 58.2439C59.3561 59.2528 57.9982 60.0018 55.8848 60.0018C52.2603 60.0018 49.918 57.5995 49.918 54.3416C49.918 51.1126 52.3869 48.6836 55.5559 48.6836C59.1538 48.6836 61.1939 51.4215 61.0184 55.2216H52.5114C52.8136 56.7972 53.9203 57.8061 55.8582 57.8061Z",
    fill: "#16140C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 57.6853L6.54689 51.034H0.151116V48.9473H9.58255V51.0762L3.03344 57.7298H9.66922V59.8143H0V57.6853Z",
    fill: "#16140C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6147 53.4126C19.3858 51.9393 18.5058 50.8548 16.7435 50.8548C15.1079 50.8548 13.9767 51.7837 13.6745 53.4126H19.6147ZM17.0213 57.8061C18.4058 57.8061 19.4125 57.2372 20.0169 56.6416L21.5014 58.2439C20.5192 59.2528 19.1613 60.0018 17.0479 60.0018C13.4211 60.0018 11.0811 57.5995 11.0811 54.3416C11.0811 51.1126 13.55 48.6836 16.719 48.6836C20.3169 48.6836 22.357 51.4215 22.1792 55.2216H13.6745C13.9767 56.7972 15.0834 57.8061 17.0213 57.8061Z",
    fill: "#16140C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5278 54.3278C45.5278 52.3944 44.0656 50.8076 42.0788 50.8076C40.1365 50.8076 38.6298 52.3499 38.6298 54.3278C38.6298 56.3056 40.1365 57.8723 42.0788 57.8723C44.0656 57.8723 45.5278 56.2834 45.5278 54.3278ZM36.3164 54.35C36.3164 50.8721 38.9121 48.6965 41.7744 48.6965C43.2144 48.6965 44.59 49.3276 45.3967 50.3276V43.9141H47.7101V59.7857H45.3967V58.2834C44.5678 59.3502 43.1922 60.0013 41.7521 60.0013C38.9809 60.0013 36.3164 57.8056 36.3164 54.35Z",
    fill: "#16140C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5254 57.4815L64.6188 56.3948C65.2099 57.3948 66.17 57.9815 67.4144 57.9815C68.7234 57.9815 69.4012 57.3081 69.4012 56.5481C69.4012 55.677 68.1345 55.4814 66.7589 55.1992C64.9033 54.808 62.9832 54.1991 62.9832 51.9613C62.9832 50.2434 64.6188 48.6567 67.1967 48.6789C69.2256 48.6789 70.7301 49.4812 71.5835 50.7857L69.639 51.8524C69.139 51.0901 68.2878 50.6123 67.1967 50.6123C65.9522 50.6123 65.3188 51.2213 65.3188 51.9168C65.3188 52.6991 66.3233 52.9169 67.8945 53.2635C69.6856 53.6547 71.7146 54.2414 71.7146 56.5037C71.7146 58.0037 70.4057 60.026 67.3033 60.0038C65.0344 60.0038 63.441 59.0904 62.5254 57.4815Z",
    fill: "#16140C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9974 54.9586L76.164 56.9587V59.7855H73.8506V43.916H76.164V54.3075L81.0753 48.9162H83.8909L79.633 53.5675L83.9998 59.7855H81.3797L77.9974 54.9586Z",
    fill: "#16140C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3277 48.6953C26.5787 48.6953 24.2764 50.4776 24.2764 53.4333V59.7824H26.632V53.7288C26.632 51.9443 27.6565 50.8776 29.4032 50.8776C31.1477 50.8776 32.0233 51.9443 32.0233 53.7288V59.7824H34.3812V53.4333C34.3812 50.4776 32.0766 48.6953 29.3277 48.6953Z",
    fill: "#16140C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZendesk);
export default __webpack_public_path__ + "static/media/zendesk.be20f9a73e45a46d13aa931ee760903c.svg";
export { ForwardRef as ReactComponent };